import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate' // 使用vee-validate（会报冲突， 因为elmentui中fields属性已使用）
import zh from 'vee-validate/dist/locale/zh_CN' // 引入中文文件
Validator.localize(zh)
const config = {
  locale: 'zh_CN',
  events: 'blur',
  // errorBagName: 'errorBags', // change if property conflicts.
  fieldsBagName: 'fieldBags' // 非常的NICE!!!
}
Vue.use(VeeValidate, config)
const dictionary = {
  zh_CN: {
    messages: {
      required: (field) => '必填项',
      email: (field) => '请重填'
    },
    attributes: {
      userPhone: '手机号',
      authPhone: '手机号'
    }
  }
}
Validator.localize(dictionary)
Validator.extend('phone', {
  getMessage: field => '请重填',
  validate: value => value.length === 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/.test(value)
})
Validator.extend('positiveNumber', {
  getMessage: field => '请输入正确的数值',
  validate: value => /^([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])$/.test(value)
})
Validator.extend('idcard', {
  getMessage: field => '请重填',
  validate: value => /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$|^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/.test(value)
})
Validator.extend('xss', {
  getMessage: field => '请不要输入&lt;script&gt;&lt;/script&gt;这样的敏感词',
  validate: value => new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>~！@#￥……&*（）——|{}【】‘；：”“'。，、？]").test(value)
})



// WEBPACK FOOTER //
// ./src/utils/validator.js